"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useStoredState = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("../constants");
const logger = (0, _checkoutUtils.getLogger)(_constants.APP_NAME, _checkoutUtils.LogLevel.Error);
const getStoredValue = (key, initialValue)=>{
    if ((0, _checkoutUtils.isSSR)()) {
        return initialValue;
    }
    const value = localStorage.getItem(key);
    if (value === null) {
        return initialValue;
    }
    try {
        return JSON.parse(value);
    } catch (error) {
        logger(error);
        return initialValue;
    }
};
const setStoredValue = (key, value)=>{
    if ((0, _checkoutUtils.isSSR)()) {
        return;
    }
    localStorage.setItem(key, JSON.stringify(value));
};
// eslint-disable-next-line @typescript-eslint/ban-types -- this is a helper type, and is valid
const isFunction = (arg)=>typeof arg === 'function';
const useStoredState = function(key, initialValue) {
    let suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
    // useStoredState is used also in packages/checkout, we need to access the same localStorage keys, due to that we can't use useTestId for key prefixes.
    const sanitized = "".concat(_testidGenerator.Team.Checkout, "-").concat(_constants.translationsNamespace, "-").concat(key).concat(suffix ? '-' : '').concat(suffix);
    const [state, setState] = (0, _react.useState)(getStoredValue(sanitized, initialValue));
    return [
        state,
        (0, _react.useCallback)((value)=>{
            setState((current)=>{
                const toSet = isFunction(value) ? value(current) : value;
                setStoredValue(sanitized, toSet);
                return toSet;
            });
        }, [
            sanitized
        ])
    ];
};
exports.useStoredState = useStoredState;
